var _effectorFileName = "/src/page-content/group-lessons/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const groupLessonsPage = declarePage({
  pageType: pagesPath.$url().pathname
});